import { useParams } from "react-router";
import { useEffect, useState } from "react";
import { IonPage, useIonRouter } from "@ionic/react";

import { Breeding } from "../../../../models";
import useBreedingService from "../../../../services/useBreedingService";
import BreedingForm from "../BreedingForm";
import { BreedingAttempt } from "../../../../models/breeding";

type RouteParams = { breedId: string; cowId: string };

export default function EditBreeding(): React.ReactElement {
  const router = useIonRouter();
  const [breeding, setBreeding] = useState<Breeding>();
  const { breedId, cowId } = useParams<RouteParams>();
  const { getBreeding, updateBreedAttempt } = useBreedingService();

  useEffect(() => {
    async function fetchBreeding() {
      const breeding = await getBreeding(breedId);
      setBreeding(breeding);
    }
    fetchBreeding();
  }, [breedId, getBreeding]);

  const onEditBreeding = async (data: BreedingAttempt) => {
    try {
      await updateBreedAttempt(breedId, data);
      router.push(`/cows/${cowId}`);
    } catch (error) {}
    // updateCow(cowId, data)
    //   .then(() => {
    //     router.push(`/cows`);
    //   })
    //   .catch((err) => {
    //     present({
    //       message: err,
    //       duration: 1500,
    //       position: "top",
    //       color: "danger",
    //     });
    //   });
  };

  return (
    <IonPage>
      {breeding && (
        <BreedingForm
          breeding={breeding}
          title={`Edit Breeding Attempt`}
          onFormSubmit={onEditBreeding}
        />
      )}
    </IonPage>
  );
}
